import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import CTAButton from "./CTAButton";

const IntroSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} className="section-light py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.9 }}
        >
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.05] text-section-light-foreground">
            Qualità vera,<br />
            servizio completo
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-8 max-w-xl ml-auto"
        >
          <p className="text-section-light-foreground/70 text-base md:text-lg leading-relaxed font-body">
            Danielealoisi è un'azienda artigiana di infissi, serramenti e lavorazioni in ferro attiva da 36 anni tra Roma e Guidonia. Ogni prodotto è realizzato 100% su misura — materiali, colori e meccanismi scelti insieme a te, mai da catalogo. Finiture precise, allineamenti perfetti e pulizia a fine intervento con smaltimento rifiuti. Tempi chiari e disponibilità reale fino alla consegna (e anche dopo).
          </p>
          <CTAButton className="cta-button-light mt-8 inline-flex hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300" />
        </motion.div>
      </div>
    </section>
  );
};

export default IntroSection;